import React, { useEffect, useState, useContext } from "react";
import { getAutoCity } from '../../Services/API';
import { getAutoAirlines } from '../../Services/API';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../Routes/AuthProvider";
import { TravelPolicies } from "../../Services/API";
import { all } from "axios";

const FlightSearch = () => {
    const { name, userName, roles, corporateId } = useContext(AuthContext);
    const [sections, setSections] = useState([]);
    const [errors, setErrors] = useState({});
    const [departureQuery, setDepartureQuery] = useState("");
    const [departureSuggestions, setDepartureSuggestions] = useState([]);
    const [AirlinesSuggestions, setAirlinesSuggestions] = useState([]);

    const [arrivalQuery, setArrivalQuery] = useState("");
    const [arrivalSuggestions, setArrivalSuggestions] = useState([]);
    const isMultiCityActive = sections.length > 0;

    const navigate = useNavigate();
    const [onwardDate, setOnwardDate] = useState(null);
    const [returnDate, setReturnDate] = useState(null);

    const [departureCity, setDepartureCity] = useState(null);
    const [arrivalCity, setArrivalCity] = useState(null);
    const [travelType, setTravelType] = useState("Domestic");

    const [policies, setPolicies] = useState([]);
    const [travelClasses, setTravelClasses] = useState([]);

    useEffect(() => {
        if (!departureCity || !arrivalCity) return;

        const type =
            departureCity.country === "IN" &&
                arrivalCity.country === "IN"
                ? "Domestic"
                : "International";

        setTravelType(type);

    }, [departureCity, arrivalCity]);

    const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
    const userId = emulateCorporateCode || corporateId;

    const CorpTravellerUserId = localStorage.getItem("selectedUserId");
    const CorpTraveller = CorpTravellerUserId ?? userName;
    useEffect(() => {
        if (!userName || !travelType || !userId || userId === "null" || userId === "undefined") return;
        const getTravelPolicies = async () => {
            try {
                const response = await TravelPolicies({
                    UserName: CorpTraveller,
                    ProductType: "Flight",
                    CorporateCode: userId,
                    TravelType: travelType
                });

                setPolicies(response);
                if (
                    response?.approvalPolicy?.result?.travelPolicies?.length > 0
                ) {
                    const classes = response.approvalPolicy.result?.travelPolicies[0].travelClass || [];
                    setTravelClasses(classes);
                    setFlightlist(prev => ({
                        ...prev,
                        selClass: classes[0] || ""
                    }));
                }

                //console.log("getTravelPolicies", response);
            } catch (error) {
                console.error(error);
            }
        };
        getTravelPolicies();
    }, [userName, userId, travelType]);

    const addSection = () => {
        setSections((prev) => {
            if (prev.length >= 3) {
                alert("You can add only up to 3 sections.");
                return prev;
            }

            // Get arrival of last section if available, otherwise leave empty
            const lastArrival = prev.length > 0 && prev[prev.length - 1].arrival
                ? prev[prev.length - 1].arrival
                : "";

            return [...prev, { departure: lastArrival, arrival: "", date: "" }];
        });
    };

    const removeSection = (index) => {
        setSections((prev) => prev.filter((_, i) => i !== index));
    };

    const handleChange = (e, index = null, field = null, fieldValue = null) => {
        if (e?.target) {
            const { name, value, type, checked } = e.target;

            setFlightlist((prev) => {
                const updated = {
                    ...prev,
                    [name]: type === "checkbox" ? checked : value
                };
                if (Number(updated.infant) > Number(updated.adult)) {
                    setErrors((prevErr) => ({
                        ...prevErr,
                        infant: "Infant cannot be more than Adult"
                    }));
                } else {
                    setErrors((prevErr) => ({
                        ...prevErr,
                        infant: ""
                    }));
                }

                return updated;
            });
        }
        else if (index !== null && field !== null) {
            setSections((prev) => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    [field]: fieldValue
                };
                return updated;
            });
        }
    };


    // --- HANDLE handleAirlineChange ---
    const handleAirlineChange = async (e) => {
        const value = e.target.value;
        if (value.length >= 2) {
            const data = await getAutoAirlines(value);
            setAirlinesSuggestions(data);
        } else {
            setAirlinesSuggestions([]);
        }
    };

    const selectAirlines = (airline) => {
        setFlightlist((prev) => ({
            ...prev,
            airlinePreference: airline.airLineCode,
            airlineName: airline.airLineName
        }));

        setAirlinesSuggestions([]);
    };


    // --- HANDLE DEPARTURE CHANGE ---
    const handleDepartureChange = async (e) => {
        const value = e.target.value;
        setDepartureQuery(value);
        if (value.length >= 2) {
            const data = await getAutoCity(value);
            setDepartureSuggestions(data);
        } else {
            setDepartureSuggestions([]);
        }
    };

    // --- HANDLE ARRIVAL CHANGE ---
    const handleArrivalChange = async (e) => {
        const value = e.target.value;
        setArrivalQuery(value);
        if (value.length >= 2) {
            const data = await getAutoCity(value);
            setArrivalSuggestions(data);
        } else {
            setArrivalSuggestions([]);
        }
    };

    // --- SELECT CITY ---
    const selectDeparture = (city) => {
        const fullName = `${city.cityName} (${city.autoCompleteCode}) - ${city.countryName}`;

        setFlightlist((prev) => ({
            ...prev,
            departureQuery: fullName,
        }));
        setDepartureCity(city);
        setDepartureSuggestions([]);
    };

    const selectArrival = (city) => {
        const fullName = `${city.cityName} (${city.autoCompleteCode}) - ${city.countryName}`;

        setFlightlist((prev) => ({
            ...prev,
            arrivalQuery: fullName,
        }));

        setArrivalCity(city);
        setArrivalSuggestions([]);
    };



    // get City


    const swapDestination = (index) => {
        setSections((prev) => {
            if (!prev[index]) return prev; // guard
            const updated = [...prev];
            const { departure, arrival } = updated[index];
            updated[index] = { ...updated[index], departure: arrival, arrival: departure };
            return updated;
        });
    };

    const swapMainDestination = (e) => {
        e.preventDefault();

        setFlightlist((prev) => ({
            ...prev,
            departureQuery: prev.arrivalQuery,
            arrivalQuery: prev.departureQuery,
        }));
    };

    const [flightlist, setFlightlist] = useState({
        departureQuery: "",
        arrivalQuery: "",
        onwardDate: "",
        returnDate: "",
        adult: "1",
        child: "",
        infant: "",
        selClass: "ECONOMY",
        airlinePreference: "",
        airlineName: "",
        timePreference: "",
        fareType: "",
        nonStop: true,
        travelType: "1",
    });

    const handleSearch = (e) => {
        const corporateCode = localStorage.getItem("selectedCorporateCode");
        const userId = localStorage.getItem("selectedUserId");

        if (
            ["TMC Operations", "TMC Manager", "Corp Travel Manager"].some(role =>
                roles?.includes(role)
            ) &&
            (!corporateCode && !userId)
        ) {
            alert("First emulate, then search for flights.");
            return;
        }

        e.preventDefault();
        let newErrors = {};

        const { departureQuery, arrivalQuery, onwardDate } = flightlist;

        if (!departureQuery.trim()) newErrors.departure = "Please select a Departure City";
        if (!arrivalQuery.trim()) newErrors.arrival = "Please select an Arrival City";
        if (!onwardDate.trim()) newErrors.onwardDate = "Please select a Departure Date";

        if (Number(flightlist.infant) > Number(flightlist.adult)) {
            newErrors.infantCount = "Infant cannot be more than Adult";
        }
        if ((Number(flightlist.adult) + Number(flightlist.child) + Number(flightlist.infant)) > 9) {
            newErrors.paxCount = "Total passengers cannot be more than 9";
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length !== 0) return;

        // save for refresh
        sessionStorage.setItem("searchData", JSON.stringify(flightlist));

        // build url
        const query = new URLSearchParams(flightlist).toString();

        navigate(`/flight/result?${query}`, {
            state: flightlist,
        });
    };

    return (
        <>
            <form onSubmit={handleSearch}>
                <section className='flight_top_banner'>
                    <div className='container'>
                        <div className='col-md-12 col-lg-12'>
                            <div className='Search_form'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='d-flex'>
                                        {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isBusinessTravelEnabled === true && (
                                            <div className="travel_mode">
                                                <div className="form-check form-check-custom form-check-solid">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="BusinessTravel"
                                                        name="travelType"
                                                        value="1"
                                                        checked={flightlist.travelType === "1"}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="BusinessTravel">
                                                        Business Travel
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                        {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isPersonalTravelEnabled === true && (
                                            <div className="travel_mode">
                                                <div className="form-check form-check-custom form-check-solid">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="PersonalTravel"
                                                        name="travelType"
                                                        value="2"
                                                        checked={flightlist.travelType === "2"}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="PersonalTravel">
                                                        Personal Travel
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                        {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isGuestTravelEnabled === true && 
                                        ["TMC Operations", "TMC Manager", "Corp Travel Manager"].some(role => roles?.includes(role)) && (
                                            <div className="travel_mode">
                                                <div className="form-check form-check-custom form-check-solid">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="GuestTravel"
                                                        name="travelType"
                                                        value="3"
                                                        checked={flightlist.travelType === "3"}
                                                        onChange={handleChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="GuestTravel">
                                                        Guest Travel
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className='col-md-12 col-lg-12'>
                                    <div className='top_main_taber'>
                                        <div className="left_taber">
                                            {/* Departure City */}
                                            <div className="input_fm_sr" style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="departureQuery"
                                                    placeholder="Departure City.."
                                                    value={flightlist.departureQuery}
                                                    onChange={(e) => {
                                                        handleChange(e);           // updates state
                                                        handleDepartureChange(e);  // fetches suggestions
                                                    }}
                                                    autoComplete="off"
                                                />

                                                {/* Suggestion List */}
                                                {departureSuggestions.length > 0 && (
                                                    <ul>
                                                        {departureSuggestions.map((city, index) => (
                                                            <li key={index} onClick={() => selectDeparture(city)}>
                                                                {city.cityName} ({city.autoCompleteCode}) - {city.countryName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {errors.departure && <p className="error">{errors.departure}</p>}

                                                <a href="#!" className="swipers" onClick={swapMainDestination}>
                                                    <img src="/assets/images/swipe.png" alt="icon" />
                                                </a>
                                            </div>

                                            {/* Arrival City */}
                                            <div className="input_fm_sr" style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="arrivalQuery"
                                                    placeholder="Arrival City.."
                                                    value={flightlist.arrivalQuery}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        handleArrivalChange(e);
                                                    }}
                                                    autoComplete="off"
                                                />

                                                {arrivalSuggestions.length > 0 && (
                                                    <ul>
                                                        {arrivalSuggestions.map((city, index) => (
                                                            <li key={index} onClick={() => selectArrival(city)}>
                                                                {city.cityName} ({city.autoCompleteCode}) - {city.countryName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}

                                                {errors.arrival && <p className="error">{errors.arrival}</p>}
                                            </div>

                                            {/* Dates */}
                                            <div className="input_fm_sr let_date ort">
                                                {/* Onward Date */}
                                                <div className="input_fm_sr let_date ort">
                                                    {/* Onward Date */}
                                                    <div className="input_fm_sr">
                                                        <DatePicker
                                                            selected={flightlist.onwardDate ? new Date(flightlist.onwardDate) : null}
                                                            onChange={(date) => {
                                                                const formatted = date.toLocaleDateString("en-CA");
                                                                setFlightlist((prev) => ({
                                                                    ...prev,
                                                                    onwardDate: formatted, //  Update flightlist
                                                                }));
                                                            }}
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Departure"
                                                            minDate={new Date()}
                                                            popperPlacement="bottom-start"
                                                        />
                                                    </div>
                                                    {errors.onwardDate && <p className="error">{errors.onwardDate}</p>}

                                                    {/* Return Date */}
                                                    <div className="input_fm_sr">
                                                        {flightlist.returnDate && (
                                                            <i
                                                                className="fa fa-close close-clear"
                                                                onClick={() =>
                                                                    setFlightlist((prev) => ({
                                                                        ...prev,
                                                                        returnDate: null,
                                                                    }))
                                                                }
                                                            ></i>
                                                        )}
                                                        <DatePicker
                                                            selected={flightlist.returnDate ? new Date(flightlist.returnDate) : null}
                                                            onChange={(date) => {
                                                                const formatted = date.toLocaleDateString("en-CA");
                                                                setFlightlist((prev) => ({
                                                                    ...prev,
                                                                    returnDate: formatted, //  Update flightlist
                                                                }));
                                                            }}
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="Return"
                                                            minDate={flightlist.onwardDate ? new Date(flightlist.onwardDate) : new Date()}
                                                            maxDate={
                                                                flightlist.onwardDate
                                                                    ? new Date(
                                                                        new Date(flightlist.onwardDate).getFullYear() + 1,
                                                                        new Date(flightlist.onwardDate).getMonth(),
                                                                        new Date(flightlist.onwardDate).getDate()
                                                                    )
                                                                    : new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                                                            }
                                                            popperPlacement="bottom-start"
                                                            disabled={isMultiCityActive}
                                                            isClearable={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="input_fm_sbc">
                                            <div className="input_fm_sr">
                                                {/* Passenger Dropdown */}
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    {Number(flightlist.adult) + Number(flightlist.child) + Number(flightlist.infant)} Total Pax
                                                </button>
                                                {errors.infantCount && <p className="error">{errors.infantCount}</p>}
                                                {errors.paxCount && <p className="error">{errors.paxCount}</p>}
                                                <div className="dropdown-menu p-3 dropdown_passenger_info">
                                                    {errors.infant && <p className="error" style={{ marginTop: "-33px" }}>{errors.infant}</p>}
                                                    <div className="passengers-types">
                                                        {/* Adults */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Adult</p>
                                                                <span>12+ yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="adult"
                                                                value={flightlist.adult}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(9)].map((_, i) => (
                                                                    <option key={i} value={i + 1}>
                                                                        {i + 1}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Children */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Children</p>
                                                                <span>2 - 12 yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="child"
                                                                value={flightlist.child}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(10)].map((_, i) => (
                                                                    <option key={i} value={i}>
                                                                        {i}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Infants */}
                                                        <div className="passengers-ty">
                                                            <div className="type-label">
                                                                <p>Infant</p>
                                                                <span>Less than 2 yrs</span>
                                                            </div>
                                                            <select
                                                                className="form-select btn_selct"
                                                                name="infant"
                                                                value={flightlist.infant}
                                                                onChange={handleChange}
                                                            >
                                                                {[...Array(10)].map((_, i) => (
                                                                    <option key={i} value={i}>
                                                                        {i}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* Class Dropdown */}
                                            <div className="input_fm_sr">
                                                <select
                                                    className="form-select form-select-solid"
                                                    name="selClass"
                                                    value={flightlist.selClass}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    {policies?.approvalPolicy?.result?.travelPolicies.length > 0
                                                        ? policies?.approvalPolicy?.result?.travelPolicies[0]?.travelClass?.map((item, index) => (
                                                            <option key={index} value={item}>
                                                                {item}
                                                            </option>
                                                        ))
                                                        : (
                                                            <>
                                                                <option value="ECONOMY">Economy</option>
                                                                <option value="PREMIUM">Premium Economy</option>
                                                                <option value="BUSINESS">Business</option>
                                                                <option value="FIRST">First Class</option>
                                                            </>
                                                        )}
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="col-md-12 col-lg-12 Add_multiple">
                                    {sections.map((section, index) => (
                                        <div className="d-flex-main" key={index}>
                                            <div className="left_taber">
                                                {/* Multi Departure City */}
                                                <div className="input_fm_sr" style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Departure City.."
                                                        value={section.multicitydeparture || ""}
                                                        onChange={(e) =>
                                                            handleChange(null, index, "departure", e.target.value)
                                                        }
                                                    />

                                                    <a
                                                        href="#!"
                                                        className="swipers"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            swapDestination(index);
                                                        }}
                                                    >
                                                        <img src="/assets/images/swipe.png" alt="icon" />
                                                    </a>
                                                </div>

                                                {/* Multi Arrival City */}
                                                <div className="input_fm_sr" style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Arrival City.."
                                                        value={section.multicityarrival || ""}
                                                        onChange={(e) =>
                                                            handleChange(null, index, "arrival", e.target.value)
                                                        }
                                                    />
                                                </div>

                                                {/* Date Picker */}
                                                <div className="input_fm_sr">
                                                    <DatePicker
                                                        selected={section.date ? new Date(section.date) : null}
                                                        onChange={(date) =>
                                                            handleChange(
                                                                null,
                                                                index,
                                                                "date",
                                                                date ? date.toISOString().split("T")[0] : ""
                                                            )
                                                        }
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select date"
                                                        minDate={new Date()}
                                                    />
                                                </div>
                                            </div>

                                            {/* Remove Button */}
                                            <div className="click_remove">
                                                <a
                                                    href="#!"
                                                    className="deleteFlight minus-signs"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        removeSection(index);
                                                    }}
                                                >
                                                    ×
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <div className='d-flex-main'>
                                    <div className="special_view_left">
                                        {/* Airline Preference */}
                                        <div className="input_fm_sr">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="airlineName"
                                                placeholder="Airlines.."
                                                value={flightlist.airlineName}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    handleAirlineChange(e);
                                                }}
                                                autoComplete="off"
                                            />

                                            {AirlinesSuggestions.length > 0 && (
                                                <ul className="suggestion-list">
                                                    {AirlinesSuggestions.map((airline, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() => selectAirlines(airline)}
                                                        >
                                                            {airline.airLineName}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>

                                        {/* Time Preference */}
                                        <div className="input_fm_sr">
                                            <select
                                                className="form-select form-select-solid"
                                                name="timePreference"
                                                value={flightlist.timePreference}
                                                onChange={handleChange}>
                                                <option value="0">Departure Time Preference</option>
                                                <option value="1">Before 6 AM</option>
                                                <option value="2">6 AM to 12 PM</option>
                                                <option value="3">12 PM to 6PM</option>
                                                <option value="4">After 6 PM</option>
                                            </select>
                                        </div>

                                        {/* Type Fare */}
                                        <div className="input_fm_srs">
                                            <div className="form-check form-check-custom form-check-solid mb-2 mt-5">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="fareType"
                                                    checked={flightlist.fareType === "Corporate Fare"}
                                                    onChange={(e) =>
                                                        setFlightlist((prev) => ({
                                                            ...prev,
                                                            fareType: e.target.checked ? "Corporate Fare" : ""
                                                        }))
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="fareType">
                                                    Corporate Fare
                                                </label>
                                            </div>
                                        </div>
                                        <div className="input_fm_srs">
                                            <div className="form-check form-check-custom form-check-solid mb-2 mt-5 mx-5">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="NonStop"
                                                    name="nonStop"
                                                    checked={flightlist.nonStop}
                                                    onChange={handleChange}
                                                />
                                                <label className="form-check-label" htmlFor="NonStop">
                                                    Non Stop
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='special_view_right'>
                                        <button className='btn btn-primary-search' type='submit'>Search </button>
                                        <button className='btn btn-primary-add' type="button" onClick={addSection} disabled={sections.length >= 2} >Add <i className='fa fa-plus'></i></button>
                                    </div>
                                </div>
                                {/* <div className='col-md-12 col-lg-12'>
                                    <div className="d-flex-stops">
                                        <div className="form-check form-check-custom form-check-solid mb-2 mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="NonStop"
                                                name="nonStop"
                                                checked={flightlist.nonStop}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="NonStop">
                                                Non Stop
                                            </label>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
            </form>

        </>

    );
};
export default FlightSearch;
